var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7832c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d7751f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.8451916 1.69645182c.1906954-.09534771.2518601-.03250558.1370908.13964844l-.3455171.51827567c-.1149823.17247341-.3483306.40571522-.5204846.52048456l-.5182757.34551712c-.1724734.11498227-.4328264.32872953-.5810052.47690836l.1564766-.15647671c-.1484069.14840695-.1496669.38776217-.0022372.53519186l.2289501.22895014c.1471714.14717135.1474297.38552493 0 .53295462l-.2289501.22895014c-.1471713.14717136-.41338023.19302586-.61176187.09383501l-.07133562-.03566778c-.19069539-.09534771-.418736-.02573939-.51792685.1726423l-.03566781.07133556c-.09534774.19069542-.3315517.3982544-.53424945.46582031l-.41964282.13988096c-.19971009.06657004-.53831847.12053572-.74255954.12053572-.21039419 0-.45440383.1469029-.55359468.3452846l-.03566778.07133556c-.09534771.19069542-.32432193.26944478-.51082502.17619324l-.84744409-.42372204c-.18677316-.09338658-.45723034-.28813898-.60466003-.43556868l-.22895014-.22895014c-.14717135-.14717135-.26647731-.44318861-.26647731-.64742969 0-.21039418.1726423-.38095238.38095238-.38095238h-.38095238c.21039419 0 .5-.11904762.64742969-.26647731l.22895014-.22895014c.14717136-.14717135.44318862-.26647731.64742969-.26647731.21039419 0 .43392218-.15890939.5014881-.36160715l.13988096-.41964285c.06657003-.19971011.28293463-.32912736.48779296-.28815569l1.17024743.23404948c.20283055.04056611.53033151.03268287.73612899-.0187665l.78606598-.19651649c.20372229-.05093056.51577467-.16566939.71415637-.26486024l.0713356-.03566778c.1906954-.09534771.4921875-.24609376.6905691-.34528461l.0713357-.03566777c.1906953-.09534771.4921875-.24609376.6905691-.34528461z",
    fill: "url(#c)",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#445128"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.761905,
    mask: "url(#d)",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.26332488 8.7423555c-.19959749.0665325-.41533844-.04133798-.48187086-.24093539-.0665325-.19959748.04133798-.41533843.24093539-.48187085.04042598-.01347536.1191491-.04346515.2228912-.08957273.17439627-.07750948.34865036-.17044495.50911931-.27742423.26955918-.17970615.46838798-.37853494.57153258-.58482415.0940911-.18818228.3229189-.26445822.5111013-.17036708.1881822.09409114.2644582.32291897.170367.51110125-.1711411.34228221-.4599313.63107246-.8303722.87803299-.199531.13302073-.41099119.24579955-.62230921.33971863-.12768648.05674956-.22896335.0953312-.29139451.11614156zm-2.2857143-.72280624c.19959745.06653242.30746793.28227337.24093544.48187085-.06653249.19959741-.28227343.30746789-.48187088.24093539-.06243115-.02081036-.16370802-.059392-.29139455-.11614156-.21131797-.09391908-.42277821-.2066979-.62230924-.33971863-.37044081-.24696053-.65923108-.53575078-.83037219-.87803299-.09409114-.18818228-.0178152-.41701011.17036709-.51110125.18818228-.09409114.41701011-.0178152.51110125.17036708.10314461.20628921.30197339.405118.57153258.58482415.16046897.10697928.33472301.19991475.50911933.27742423.10374204.04610758.18246517.07609737.22289117.08957273z",
    mask: "url(#d)",
    opacity: 0.75
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCy);
export default __webpack_public_path__ + "static/media/CY.5ffe67a91973e555816feb09fcf589ea.svg";
export { ForwardRef as ReactComponent };